import classNames from 'classnames'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { Me } from 'service/user'
import { useScriptStore } from 'store/useScriptStore'
import useUserStore from 'store/useUserStore'
import { FormValues } from 'utils/type'

interface FirstStepProps {
  watch?: UseFormWatch<FormValues>
  setValue?: UseFormSetValue<FormValues>
  setMode: Dispatch<SetStateAction<'record' | 'file' | null>>
  mode: 'record' | 'file' | null
}
export const FirstStep = ({
  watch,
  setValue,
  setMode,
  mode,
}: PropsWithChildren<FirstStepProps>) => {
  const userInfo: Me = useUserStore((state: any) => state.userInfo)
  const [isFile, setIsFile] = useState(false) // false 직접녹음 true면 녹음파일 사용

  const handleAiGenerateScript = () => {}

  return (
    <div
      className={classNames('flex gap-4  md:h-[450px]', {
        'flex-col ': isMobile,
      })}
    >
      <div
        className={classNames(
          ' relative rounded-[20px] min-h-[215px] border-[2px] flex flex-col gap-4 p-4 cursor-pointer hover:bg-[#F6FEFF] hover:outline hover:outline-[2px] hover:outline-[#AFECEC]',
          {
            'bg-[#F6F8FB]': mode === 'file',
            'bg-[#E9F8F9] outline outline-[2px] outline-[#00B7B9] ':
              mode === 'record',
            'w-[50%] h-[280px]': !isMobile,
            'w-full': isMobile,
          }
        )}
        onClick={() => {
          setIsFile(false)
          setMode('record')
        }}
      >
        {/* <p className="w-[88px] h-[25px] rounded-[4px] absolute font-bold bg-[#8C9DC2] text-[white] right-2 ">
          기능 준비중
        </p> */}
        <p className="text-[64px] text-left leading-[64px]">️️🎙️</p>
        <p className="text-left font-bold text-[32px] leading-[36px]">
          지금 바로
          <br />내 목소리 녹음
        </p>
        <p className="text-left">
          패스트컷이 제공하는 대본과 녹음 기능을 사용해서 녹음을 시작합니다.
        </p>
      </div>
      <div
        className={classNames(
          'rounded-[20px] min-h-[215px] border-[2px] flex flex-col p-4 gap-4  cursor-pointer hover:bg-[#F6FEFF] hover:outline hover:outline-[2px] hover:outline-[#AFECEC]',
          {
            'bg-[#F6F8FB]': mode === 'record',
            'bg-[#E9F8F9] outline outline-[2px] outline-[#00B7B9]':
              mode === 'file',
            'w-[50%] h-[280px]': !isMobile,
            'w-full': isMobile,
          }
        )}
        onClick={() => {
          setIsFile(true)
          setMode('file')
        }}
      >
        <p className="text-[64px] text-left leading-[64px]">️️📂</p>
        <p className="text-left font-bold text-[32px] leading-[36px]">
          내 목소리 녹음한
          <br />
          파일 업로드
        </p>
        <p className="text-left">
          패스트컷이 제공해드리는 대본을 녹음해서 파일로 업로드 해주세요!
        </p>
      </div>
    </div>
  )
}
